import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { HisBaseGlobalsService } from '../../../../core/service/base/his-base-globals.service';
interface LongTextSetting {
    value: string;
    label: string;
    helptext?: string;
    required: boolean;
    minLength?: number;
    maxLength?: number;
    regex?: string;
    readonly: boolean;
    name: string;
}


@Component( {
    selector: 'his-long-text-job-setting',
    templateUrl: './his-long-text-job-setting.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
} )
export class HisLongTextJobSettingComponent {
    setting = input.required<LongTextSetting>();
    private baseGlobalService = inject( HisBaseGlobalsService );

    protected title = computed( () => {
        if (this.baseGlobalService.system.operationMode !== 'cust') {
            return '';
        }
        return this.setting().name;
    });
}
